import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { TableRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";
import { getTableFromRegion } from "../../tables/utils";

type Props = {
  fragment: TableRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function TableRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "table",
      regionId: fragment.id,
      table: getTableFromRegion(fragment),
    });
  };

  return (
    <RegionTypeCard
      title={t("TableRegionTypeCard.title")}
      description={t("TableRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
